//统计图悬浮框
<template>
  <i-Modal v-model="isShow" title="统计图" :mask="false" ref="thematicchart" width="400">
    <div>
      <div style="margin-bottom: 5px; display: inline-flex;">
        <span style="line-height: 24px;">专题：</span>
        <i-Select
            style="width: 150px;"
            size="small"
            v-model="planId"
            @on-change="onPlanChange"
        >
          <i-Option
              v-for="(item, i) in plans"
              :key="i"
              :value="item.planId"
          >
            {{ item.title }}
          </i-Option>
        </i-Select>
        <div style="margin-left: 1em;" v-show="isDPS">
          <i-RadioGroup
              style="width: 100px;"
              v-model="chartType"
              type="button"
              @click="chartTypeChange"
              size="small"
          >
            <i-Radio
                style="padding: 0 1px;"
                label="bar"
                @click="chartTypeChange"
            >
              <i class="icon-column" title="柱状图"></i>
            </i-Radio>
            <i-Radio
                style="padding: 0 1px;"
                label="line"
                @click="chartTypeChange"
            >
              <i class="icon-line" title="折线图"></i>
            </i-Radio>
            <i-Radio
                style="padding: 0 1px;"
                label="pie"
                @click="chartTypeChange"
            >
              <i class="icon-pie" title="饼状图"></i>
            </i-Radio>
          </i-RadioGroup>
        </div>
      </div>
      <div
          id="chart"
          ref="chart"
          style="height: 250px; width: 350px;"
      ></div>

    </div>
    <div slot="footer">
    </div>
  </i-Modal>
</template>

<script>
import Drag from '@/components/Drag.vue';

import { getFeatureValues } from '@/utils/serviceUtil/wfsUtil.js';
import { queryDPS } from '@/utils/serviceUtil/dpsUtil.js';
import { queryDQS } from '@/utils/serviceUtil/dqsUtil.js';
import { deepCopy } from '@/utils/miscUtil'
import { eventMgr } from './events';
import {MiscUtil} from "../../../utils/miscUtil";

export default {
    unWatch() {
        return {
            charts: null,
            option: null,
        };
    },
    data() {
        return {
            seriesData: [],
            xAxisData: [],
            text: 1,
            eventName: '',
            isShow: true,
            chartType: 'bar',
            plan: {},
            plans: [],
            plansTt: [],
            planId: null,
        };
    },
    computed: {
        isDPS() {
            if (this.plan && this.plan.configcont) {
                return this.plan.configcont.thematic.serviceType !== 'DQS';
            } else {
                return false;
            }
        },
    },
    watch: {
        chartType() {
            this.chartTypeChange();
        },
    },
    mounted() {
        eventMgr.on('switchChartDisplay', this.switchDisplay);
        eventMgr.on('addChartPlan', this.addChartPlan);
        eventMgr.on('removeChartPlan', this.removeChartPlan);
        eventMgr.on('changeChartPlan', this.changeChartPlan);
        eventMgr.on('changeChartSelect', this.changeChartSelect);
        this.charts = echarts.init(this.$refs.chart);
        this.charts.on('mouseover', this.onChartHover);
    },
    beforeDestroy() {
        eventMgr.off('switchChartDisplay', this.switchDisplay);
        eventMgr.off('addChartPlan', this.addChartPlan);
        eventMgr.off('removeChartPlan', this.removeChartPlan);
        eventMgr.off('changeChartPlan', this.changeChartPlan);
        eventMgr.off('changeChartSelect', this.changeChartSelect);
    },
    methods: {
        //鼠标事件 主动触发修改选择项
        onChartHover(params) {
            params.title = this.plan.configcont.thematic.mapMatchField;
            params.value = this.plan.configcont.thematic.mapQueryField;
            params.name = this.xAxisData[params.dataIndex];
            params.eventName = 'chart';
            eventMgr.fire('changeChartsSelect', params);
        },
        //被动触发修改选择项
        changeChartSelect(evt) {
            if (evt.eventName !== 'chart') {
                if (this.charts.getOption().series.length > 0) {
                    const indexs = [];
                    const len = this.charts.getOption().series[0].data.length;
                    for (let i = 0; i < len; i++) {
                        indexs.push(i);
                    }
                    // 取消之前高亮的图形
                    this.charts.dispatchAction({
                        type: 'downplay',
                        seriesIndex: indexs,
                    });
                    const currentIndex = this.xAxisData.findIndex(
                        value => value === evt.name
                    );
                    // 高亮当前图形
                    this.charts.dispatchAction({
                        type: 'highlight',
                        seriesIndex: 0,
                        dataIndex: currentIndex,
                    });
                    // 显示 tooltip
                    this.charts.dispatchAction({
                        type: 'showTip',
                        seriesIndex: 0,
                        dataIndex: currentIndex,
                    });
                }
            }
        },
        addChartPlan(planInfo) {
            this.plan = planInfo;
            this.plans.push(this.plan);
            this.plansTt.push(this.plan);
            this.planId = this.plan.planId;
            this.showPlan();
        },
        removeChartPlan(planId) {
            const index = this.plans.findIndex(plan => {
                return plan.planId === planId;
            });
            if (index > -1) {
                if (this.plans[index].planId === this.planId) {
                    if (this.plans.length === 1) {
                        this.$CompManager.remove(this);
                    } else {
                        this.plans.splice(index, 1);
                        this.plan = this.plans[this.plans.length - 1];
                        this.planId = this.plan.planId;
                        this.showPlan();
                    }
                } else {
                    this.plans.splice(index, 1);
                }
            }
        },
        showPlan() {
            this.plan = this.plansTt.find(plan => {
                return this.planId === plan.planId;
            });
            if (this.plan) {
                this.charts.clear();
                switch (this.plan.configcont.thematic.serviceType) {
                    case 'WFS':
                        this.wfsPlan();
                        break;
                    case 'DPS':
                        this.dpsPlan();
                        break;
                    case 'DQS':
                        this.dqsPlan();
                        break;
                    default:
                        break;
                }
            }
        },
        //主动切换方案
        onPlanChange(val) {
            this.plan = this.plansTt.find(plan => {
                return val === plan.planId;
            });
            if (this.plan !== undefined) {
                this.showPlan();
                const params = {};
                params.id = this.planId;
                params.eventName = 'chart';
                params.title = this.plan.configcont.thematic.mapMatchField;
                params.value = this.plan.configcont.thematic.mapQueryField;
                eventMgr.fire('changeChartsPlan', params);
            }
        },
        //被动切换方案
        changeChartPlan(evt) {
            if (evt.eventName !== 'chart') {
                if (this.planId !== evt.id) {
                    this.planId = evt.id;
                    this.showPlan();
                }
            }
        },
        wfsPlan() {
            const ChartFields = this.plan.configcont.thematic
                .serviceChartFields;
            if (ChartFields !== undefined && ChartFields.length > 0) {
                let wfsUrl = this.plan.configcont.thematic.serviceUrl;
                //  wfsUrl= MiscUtil.getProxyUrl(wfsUrl)
                const typeName = this.plan.configcont.thematic.serviceLayer;
                let fieldString = '';
                const fields = this.plan.configcont.thematic.serviceTableFields;
                const xField = this.plan.configcont.thematic.serviceQueryField;
                // const seriesField = this.plan.configcont.thematic
                //     .serviceChartFields[0].name;
                for (let i = 0; i < fields.length; i++) {
                    if (i === fields.length - 1) {
                        fieldString = fieldString + fields[i].name;
                    } else {
                        fieldString = fieldString + fields[i].name + ',';
                    }
                }
                const seriesData = [];
                const xAxisData = [];
                const _this = this;
                getFeatureValues(wfsUrl, typeName, fieldString).then(data => {
                    if (data.length > 0 && this.plan !== undefined) {
                        for (let i = 0; i < data.length; i++) {
                            // seriesData.push(parseFloat(data[i].data[seriesField]))
                            xAxisData.push(data[i].data[xField]);
                        }
                        const chartFields = this.plan.configcont.thematic
                            .serviceChartFields;
                        const series = [];
                        const legend = [];
                        let yName = '';
                        chartFields.forEach(field => {
                            const seriesData = [];
                            data.forEach(feature => {
                                const num = Number(feature.data[field.name]);
                                if (!isNaN(num)) {
                                    // seriesData.push(num)
                                    seriesData.push({
                                        name: feature.data[xField],
                                        value: num,
                                    });
                                    yName = field.alias;
                                }
                            });
                            if (seriesData.length > 0) {
                                legend.push(field.name);
                                series.push({
                                    name: field.name,
                                    type: 'bar',
                                    data: seriesData,
                                    // itemStyle: {
                                    //   // 点的颜色。
                                    //   color: 'red'
                                    // },
                                    emphasis: {
                                        itemStyle: {
                                            // 高亮时点的颜色。
                                            color: '#187aff',
                                        },
                                    },
                                });
                            }
                        });
                        _this.seriesData = seriesData;
                        _this.xAxisData = xAxisData;
                        // 指定图表的配置项和数据
                        const option = {
                            tooltip: {},
                            legend: {
                                data: legend,
                            },
                            xAxis: {
                                name: xField,
                                data: xAxisData,
                            },
                            grid: {
                                left: 55,
                                right: 55,
                            },
                            yAxis: {
                                name: yName,
                            },
                            series: series,
                        };
                        // 使用刚指定的配置项和数据显示图表。
                        _this.option = option;
                        _this.charts.setOption(option);
                    }
                });
            }
        },
        dpsPlan() {
            const url = this.plan.configcont.thematic.serviceUrl;
            if (url !== '') {
                const dataSetId = this.plan.configcont.thematic.dataSetId;
                const fields = this.plan.configcont.thematic.serviceChartFields;
                const xField = this.plan.configcont.thematic.serviceQueryField;
                // const seriesField = this.plan.configcont.thematic
                //     .serviceChartFields[0].name;
                const colFilter = [];
                for (let i = 0; i < fields.length; i++) {
                    colFilter.push(fields[i].name);
                }
                const seriesData = [];
                const xAxisData = [];
                const _this = this;
                queryDPS(url, dataSetId, colFilter).then(data => {
                    if (data.features) {
                        const features = data.features;
                        for (let i = 0; i < features.length; i++) {
                            xAxisData.push(features[i].attributes[xField]);
                        }
                        const chartFields = this.plan.configcont.thematic
                            .serviceChartFields;
                        const series = [];
                        const legend = [];
                        chartFields.forEach(field => {
                            const seriesData = [];
                            features.forEach(feature => {
                                const num = Number(
                                    feature.attributes[field.name]
                                );
                                if (!isNaN(num)) {
                                    // seriesData.push(num)
                                    seriesData.push({
                                        name: feature.attributes[xField],
                                        value: num,
                                    });
                                }
                            });
                            if (seriesData.length > 0) {
                                legend.push(field.name);
                                series.push({
                                    name: field.name,
                                    type: 'bar',
                                    data: seriesData,
                                    // itemStyle: {
                                    //   // 点的颜色。
                                    //   color: 'red'
                                    // },
                                    emphasis: {
                                        itemStyle: {
                                            // 高亮时点的颜色。
                                            color: '#187aff',
                                        },
                                    },
                                });
                            }
                        });
                        _this.seriesData = seriesData;
                        _this.xAxisData = xAxisData;
                        // 指定图表的配置项和数据
                        const option = {
                            tooltip: {},
                            legend: {
                                data: legend,
                            },
                            xAxis: {
                                data: xAxisData,
                            },
                            yAxis: {},
                            grid: {
                                left: 55,
                                right: 0,
                            },
                            series: series,
                        };
                        // 使用刚指定的配置项和数据显示图表。
                        _this.option = option;
                        _this.charts.setOption(option);
                    }
                });
            }
        },
        dqsPlan() {
            const url = this.plan.configcont.thematic.serviceUrl;
            if (url !== '') {
                const _this = this;
                queryDQS(url, []).then(data => {
                    if (
                        data.features &&
                        data.features[0].attributes.chartOption
                    ) {
                        const option = JSON.parse(
                            data.features[0].attributes.chartOption
                        );
                        _this.option = option;
                        _this.charts.setOption(option);
                    }
                });
            }
        },
        switchDisplay(show) {
            if (show !== undefined) {
                this.isShow = show;
            } else {
                this.isShow = !this.isShow;
            }
        },
        chartTypeChange() {
            const type = this.chartType;
            for (let i = 0; i < this.option.series.length; i++) {
                this.option.series[i].type = type;
            }
            const option = deepCopy(this.option);
            if (type === 'pie') {
                option.series[0].label = {
                    emphasis: {
                        show: false,
                    },
                    normal: {
                        show: false,
                    },
                };
                // option.series[0].label = {
                //     position: 'outer',
                //     alignTo: 'labelLine',
                //     bleedMargin: 10
                // }
                delete option.xAxis;
                delete option.yAxis;
            }
            this.charts.setOption(option, true);
        },
        onClose() {
            // this.$CompManager.remove(this)
            this.isShow = false;
        },
    },
};
</script>
